import { FormikProps } from 'formik';
import moment from 'moment';
import { saveAs } from 'file-saver';

export class GeneralHelper {
  public static getInputClasses(formik: FormikProps<any>, fieldName: string): string {
    if (GeneralHelper.formFieldHasError(formik, fieldName)) {
      return 'is-invalid';
    }
    if (formik.touched[fieldName] && !formik.errors[fieldName]) {
      return 'is-valid';
    }
    return '';
  }

  public static formFieldHasError(formik: FormikProps<any>, fieldName: string): boolean {
    return formik.touched[fieldName] !== undefined && formik.errors[fieldName] !== undefined;
  }

  public static getInitials(value: string): string {
    const initials: RegExpMatchArray | null = value.replace(/[^a-zA-Z- ]/g, '').match(/\b\w/g);
    return initials ? initials.join('') : '';
  }

  public static formatDate(date: any, includeTime: boolean = false, dateFormat: string = 'DD MMMM YYYY'): string {
    if (includeTime) {
      dateFormat += ' HH:mm:ss';
    }
    return date !== '' && date.length > 0 ? moment(date).format(dateFormat) : '-';
  }

  public static formatCurrency(amount: number): string {
    // Create our number formatter.
    const formatter = new Intl.NumberFormat('en-ZA', {
      style: 'currency',
      currency: 'ZAR',

      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    return formatter.format(amount); /* $2,500.00 */
  }

  public static getDevice(): string {
    return 'WE DONT CARE';
  }

  public static downloadCsv(csvString: string, fileName: string): void {
    const blob = new Blob([`${csvString}`], { type: 'text/CSV;charset=utf-8' });
    saveAs(blob, `${fileName}`);
  }

  public static generateSlug(name: string): string {
    const dict: any = { á: 'a', è: 'e', ç: 'c', é: 'e', ë: 'e', ê: 'e', ò: 'o', ö: 'o', ô: 'o', ó: 'o', î: 'i', í: 'i' };
    return name
      .toLowerCase()
      .replace(/[^\w ]/g, (char: string) => dict[char] || char)
      .replace(/ /g, '-');
  }
}
